import React, { useMemo } from "react";

import { AutoFields, EditView, useGet } from "@builtbypixel/nucleus";
import useSWR from "swr";
import setup from "./setup";

const EditForm = () => {
  const { data: blogCategories } = useSWR("/blog-categories", useGet);

  const fields = useMemo(
    () => [
      {
        group: "",
        fields: [
          {
            name: "title",
            component: "text",
            placeholder: "Article Title",
            label: "Article Title",
            isRequired: true,
            rules: { required: true },
          },
          {
            name: "content.excerpt",
            component: "text",
            placeholder: "Article Excerpt",
            label: "Article Excerpt",
            isRequired: true,
            rules: { required: true },
            help: "please enter an excerpt for the article - Text only",
          },
          {
            name: "content.body",
            component: "richtext",
            label: "Article Content",
            isRequired: true,
            rules: { required: true },
            toolbarButtons: [
              ["paragraphFormat", "bold", "italic", "underline", "align", "fontSize"],
              [
                "insertLink",
                process.env.REACT_APP_UPLOAD_METHOD !== "cloudinary"
                  ? "insertImage"
                  : "cloudinaryImage",
                "insertVideo",
                "insertTable",
                "emoticons",
                "specialCharacters",
              ],
              ["formatOL", "formatUL"],
            ],
            paragraphFormat: {
              N: "Normal",
              H2: "Heading 2",
              H3: "Heading 3",
              H4: "Heading 4",
            },
          },
          {
            name: "content.thumbnail",
            component: "file",
            max: 1,
            label: "Thumbnail",
            isRequired: true,
            rules: { required: true },
          },
          {
            name: "content.homepage_thumbnail",
            component: "file",
            max: 1,
            label: "Home Page Thumbnail",
            isRequired: true,
            rules: { required: true },
            help: "This image will be used for the Home Page blog thumbnail. Use a different aspect ratio if needed.",
          },
          {
            name: "content.image",
            component: "file",
            max: 1,
            label: "Image",
            isRequired: true,
            rules: { required: true },
          },

          {
            name: "date",
            component: "date",
            valueKey: "id",
            label: "Date",
            isRequired: true,
            rules: { required: true },
          },
          {
            name: "category",
            component: "select",
            isMulti: true,
            options: blogCategories?.data,
            labelKey: "name",
            valueKey: "id",
            label: "Blog Category",
            isRequired: true,
            rules: { required: true },
          },

          {
            name: "active",
            component: "switch",
            label: "Active?",
          },
          {
            name: "content.countdown_date",
            component: "dateTime",
            placeholder: "Set Countdown Timer",
            label: "Countdown Timer",
          },
          {
            name: "content.countdown_active",
            component: "switch",
            label: "Countdown Timer Active",
            defaultValue: false,
          },
        ],
      },
      {
        group: "Meta Information",
        fields: [
          {
            name: "seo_index.meta_title",
            component: "text",
            placeholder: "Meta Title",
            label: "Meta Title",
            help: "The title shown in search results and the browser tab. Leave blank to use the article title. Aim for 50 to 60 characters.",
          },
          {
            name: "seo_index.meta_description",
            component: "textarea",
            placeholder: "Meta Description",
            label: "Meta Description",
            help: "The summary shown under the title in search results. Leave blank to use the article excerpt. Aim for 150 to 160 characters.",
          },
          {
            name: "seo_index.meta_keywords",
            component: "textarea",
            placeholder: "Meta Keywords",
            label: "Meta Keywords",
            help: "Optional. Separate keywords with commas.",
          },
        ],
      },
    ],
    [blogCategories]
  );
  return (
    <EditView setup={setup} isFullWidth>
      <AutoFields fields={fields} />
    </EditView>
  );
};

export default EditForm;
